<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link
              :to="{ path: '/' }"
            >首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>基础设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>App配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">App配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ak-setting :options="options" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [
        {
          title: '首页banner',
          inputs: [
            {
              name: 'banner',
              note: 'banner图片',
              type: 'Array',
              items: {
                type: 'Image'
              },
              validators: [
                (val) => val ? null : '首页banner不可为空',
                (val) => val.length !== 0 ? null : '首页banner不可为空',
                (val) => val.length > 5 ? '首页banner不可超过五张' : null
              ]
            }
          ]
        },
        {
          title: '常见问题',
          inputs: [
            {
              name: 'faq',
              note: '常见问题',
              type: 'Html',
              validators: [
                (val) => val ? null : '常见问题不可为空'
              ]
            }
          ]
        },
        {
          title: '使用条款(ZH)',
          inputs: [
            {
              name: 'userAgreement',
              note: '条款内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '使用条款不可为空'
              ]
            }
          ]
        },
        {
          title: '隐私协议(ZH)',
          inputs: [
            {
              name: 'privacyPolicy',
              note: '协议内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '隐私政策不可为空'
              ]
            }
          ]
        },
        {
          title: '使用条款(EN)',
          inputs: [
            {
              name: 'userAgreement_English',
              note: '条款内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '使用条款不可为空'
              ]
            }
          ]
        },
        {
          title: '隐私协议(EN)',
          inputs: [
            {
              name: 'privacyPolicy_English',
              note: '协议内容',
              type: 'Html',
              validators: [
                (val) => val ? null : '隐私政策不可为空'
              ]
            }
          ]
        },
        {
          title: '操作视频',
          inputs: [
            {
              name: 'video',
              note: '操作视频',
              type: 'Video'
            }
          ]
        },
        {
          title: '关于我们',
          inputs: [
            {
              note: '微博',
              name: 'weibo',
              type: 'String',
              validators: [
                (val) => val ? null : '微博不可为空'
              ]
            },
            {
              note: '网址',
              name: 'website',
              type: 'String',
              validators: [
                (val) => val ? null : '网址不可为空'
              ]
            },
            {
              note: '电话',
              name: 'phone',
              type: 'String',
              validators: [
                (val) => val ? null : '电话不可为空'
              ]
            },
            {
              note: '邮箱',
              name: 'email',
              type: 'String',
              validators: [
                (val) => val ? null : '邮箱不可为空'
              ]
            },
            {
              note: '地址(简体)',
              name: 'address_zh',
              type: 'String',
              validators: [
                (val) => val ? null : '地址不可为空'
              ]
            },
            {
              note: '地址(繁体)',
              name: 'address_hant',
              type: 'String',
              validators: [
                (val) => val ? null : '地址不可为空'
              ]
            },
            {
              note: '地址(英文)',
              name: 'address_en',
              type: 'String',
              validators: [
                (val) => val ? null : '地址不可为空'
              ]
            },
            {
              note: '地址(日语)',
              name: 'address_ja',
              type: 'String',
              validators: [
                (val) => val ? null : '地址不可为空'
              ]
            }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-header {
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    margin: -24px -24px 24px -24px;
    .breadcrumb {
      margin-bottom: 16px;
    }
    .detail {
      display: flex;
      /*margin-bottom: 16px;*/
      .avatar {
        flex: 0 1 72px;
        margin: 0 24px 8px 0;
        & > span {
          border-radius: 72px;
          display: block;
          width: 72px;
          height: 72px;
        }
      }
      .main {
        width: 100%;
        flex: 0 1 auto;
        .row {
          display: flex;
          width: 100%;
          .avatar {
            margin-bottom: 16px;
          }
        }
        .title {
          font-size: 20px;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 16px;
          flex: auto;
        }
        .logo {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          margin-right: 16px;
        }
        .content,
        .headerContent {
          flex: auto;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 32px;
            }
          }
        }
        .extra {
          flex: 0 1 auto;
          margin-left: 88px;
          min-width: 242px;
          text-align: right;
        }
        .action {
          margin-left: 56px;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: right;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
  .mobile .page-header {
    .main {
      .row {
        flex-wrap: wrap;
        .avatar {
          flex: 0 1 25%;
          margin: 0 2% 8px 0;
        }
        .content,
        .headerContent {
          flex: 0 1 70%;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .extra {
          flex: 1 1 auto;
          margin-left: 0;
          min-width: 0;
          text-align: right;
        }
        .action {
          margin-left: unset;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: left;
          margin-bottom: 12px;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
</style>
